<template>
    <el-dialog :title="(formData.edit? $t('Update patenkind'):$t('Create patenkind'))" :visible.sync="dialogFormVisible"
        :before-close="handleClose" @open="handleOpen('formData')">
        <el-form label-position="top" :model="formData" ref="formData" :rules="rules">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-alert style="margin-bottom: 10px;" effect="dark" :title="$t('Fields with a ! Can be viewed by the board members. Please anonymise text for data protection reasons.')" type="warning" show-icon></el-alert>
                </el-col>
            <!-- <el-row :gutter="20"> -->
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('First Name')" prop="first_name">
                        <el-input v-model="formData.first_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('Last Name')" prop="last_name">
                        <el-input v-model="formData.last_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('Initials of the godchild (e.g. A.Z.)')" class="exclamation-mark" prop="nick_name">
                        <el-input v-model="formData.nick_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="!$store.state.config.user.fachstellen_slug && !fachstellen_slug">
                    <el-form-item :label="$t('Fachstellen type')" prop="fachstellen_type">
                        <el-select v-model="formData.fachstellen_type" :placeholder="$t('Fachstellen type')" filterable
                            @change="fachstellenTypeChange">
                            <el-option v-for="(item) in fachstellenType" :label="item.label" :key="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <input type="hidden" v-model="formData.fachstellen_slug" v-if="$store.state.config.user.fachstellen_slug || fachstellen_slug">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-else>
                    <el-form-item :label="$t('Fachstellen')" prop="fachstellen_slug">
                        <el-select v-model="formData.fachstellen_slug" :placeholder="$t('Select Fachstellen')"
                            filterable>
                            <el-option v-for="(item) in fachstellenName.data" :label="item.display_name" :key="item.slug"
                                :value="item.slug"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('Origin country')" prop="origin_country">
                        <el-select v-model="formData.origin_country" :placeholder="$t('Select country')" filterable :filter-method="filterCountry">
                            <el-option v-for="(item) in filteredCountry" :label="item" :key="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('Legal representatives')" prop="legal_parent_name">
                        <el-input v-model="formData.legal_parent_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Address')" prop="address" :rules="[{ required: true, message: $t('This field is required'),trigger: ['blur', 'change']}]">
                    <vue-google-autocomplete :country="['ch', 'so', 'iq']" v-model="formData.address" ref="address" id="map"
                        classname="el-input__inner" placeholder="Start typing" v-on:placechanged="getAddressData"
                        @change="handleAddressChange"></vue-google-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Place')" prop="place" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.place"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Zipcode')" prop="zipcode" :rules="[{ required: true, message: $t('This field is required')},{ pattern:/^[1-9]\d{3,4}$/, trigger: ['blur', 'change'], message: $t('Please enter valid zipcode')}]">
                    <el-input type="zipcode" v-model="formData.zipcode"></el-input>
                </el-form-item>
            </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <el-form-item :label="$t('Legal representatives relation')" prop="legal_parent_type">
                        <el-radio-group v-model="formData.legal_parent_type">
                            <el-radio label="parent">{{ $t('Parent') }}</el-radio>
                            <el-radio label="guardian">{{ $t('Guardian') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                    <el-form-item :label="$t('Life situation')" prop="life_situation">
                        <el-radio-group v-model="formData.life_situation">
                            <el-radio label="needy">{{ $t('Needy') }}</el-radio>
                            <el-radio label="special">{{ $t('Special') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('DOB')" prop="dob">
                        <el-date-picker v-model="formData.dob" type="date" placeholder="Pick a day" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="formData.edit">
                    <el-form-item :label="$t('Leaving')" prop="leaving">
                        <el-date-picker v-model="formData.leaving" type="datetime" placeholder="Pick a day" format="dd-MM-yyyy HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('Gender')" prop="gender">
                        <el-radio-group v-model="formData.gender">
                            <el-radio label="Male">{{ $t('Male') }}</el-radio>
                            <el-radio label="Female">{{ $t('Female') }}</el-radio>
                            <el-radio label="Other">{{ $t('Other') }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="2" :md="2" :lg="4" :xl="4">
                    <el-form-item :label="$t('Status')" prop="status">
                        <el-switch v-model="formData.status" active-color="#13ce66" inactive-color="#ff4949"
                            active-value="active" inactive-value="inactive">
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-form-item :label="$t('Description')" prop="description">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}"  v-model="formData.description"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-form-item :label="$t('Office comments')" prop="office_comments">
                        <!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" :disabled="($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')? false : true" v-model="formData.office_comments"></el-input> -->
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" :disabled="($store.state.config.user.role_slug == 'main-admin')? false : true" v-model="formData.office_comments"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" hidden>
                    <el-form-item :label="$t('Publication')" prop="publication_type">
                        <el-radio-group class="publication_type" v-model="formData.publication_type">                            
                            <el-radio label="no" >
                                {{ $t('NO, no data may be published on the KiPaKi homepage') }}
                            </el-radio>
                            <el-radio label="other">
                                {{ $t('Only the following data may be published') }}
                            </el-radio>
                        </el-radio-group>
                        <el-input v-if="formData.publication_type == 'other'" v-model="formData.publication_description"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-form-item>
                    <h3>{{ $t('Admission criteria') }}:</h3>
                    <el-row>
                        <el-col :xs="24" :sm="17" :md="18" :lg="18" :xl="18">
                            <span class="admision-label">{{ $t('The godchild is younger than 17 years or has no income (from profession or teaching)') }}</span>
                        </el-col>
                        <el-col :xs="10" :sm="4" :md="3" :lg="3" :xl="3">
                            <el-radio label="yes" v-model="formData.q_ans_1">
                               {{ $t('Yes') }}
                            </el-radio>
                        </el-col>
                        <el-col :xs="10" :sm="3" :md="3" :lg="3" :xl="3">
                            <el-radio label="no" v-model="formData.q_ans_1">
                               {{ $t('No') }}
                            </el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="17" :md="18" :lg="18" :xl="18">
                            <span class="admision-label">{{ $t('Application and supervision of sponsorship / support services are provided by the department?') }}</span>
                        </el-col>
                        <el-col :xs="10" :sm="4" :md="3" :lg="3" :xl="3">
                            <el-radio label="yes" v-model="formData.q_ans_2">
                                {{ $t('Yes') }}
                            </el-radio>
                        </el-col>
                        <el-col :xs="10" :sm="3" :md="3" :lg="3" :xl="3">
                            <el-radio label="no" v-model="formData.q_ans_2">
                                {{ $t('No') }}
                            </el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="17" :md="18" :lg="18" :xl="18">
                          <span class="admision-label"> {{ $t('It is pursued with the godchild a longer-term goal. (Recurring Benefits)') }}</span>
                        </el-col>
                        <el-col :xs="10" :sm="4" :md="3" :lg="3" :xl="3">
                            <el-radio label="yes" v-model="formData.q_ans_3">
                                {{ $t('Yes') }}
                            </el-radio>
                        </el-col>
                        <el-col :xs="10" :sm="3" :md="3" :lg="3" :xl="3">
                            <el-radio label="no" v-model="formData.q_ans_3">
                                {{ $t('No') }}
                            </el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="17" :md="18" :lg="18" :xl="18">
                           <span class="admision-label"> {{ $t('It can be ensured that the respective support lines exclusively benefit the child.')
                            }}</span>
                        </el-col>
                        <el-col :xs="10" :sm="4" :md="3" :lg="3" :xl="3">
                            <el-radio label="yes" v-model="formData.q_ans_4">
                                {{ $t('Yes') }}
                            </el-radio>
                        </el-col>
                        <el-col :xs="10" :sm="3" :md="3" :lg="3" :xl="3">
                            <el-radio label="no" v-model="formData.q_ans_4">
                                {{ $t('No') }}
                            </el-radio>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="17" :md="18" :lg="18" :xl="18">
                           <span class="admision-label"> {{ $t('There are/were no conflicts with authorities or public bodies.')
                            }}</span>
                        </el-col>
                        <el-col :xs="10" :sm="4" :md="3" :lg="3" :xl="3">
                            <el-radio label="yes" v-model="formData.q_ans_5">
                                {{ $t('Yes') }}
                            </el-radio>
                        </el-col>
                        <el-col :xs="10" :sm="3" :md="3" :lg="3" :xl="3">
                            <el-radio label="no" v-model="formData.q_ans_5">
                                {{ $t('No') }}
                            </el-radio>
                        </el-col>
                    </el-row>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="!formData.edit">
                    <el-form-item prop="confirmation">
                        <h3>{{ $t('Confirmation')  }}:</h3>
                        <el-checkbox class="terms" label="yes" v-model="formData.confirmation" style="word-break: break-word;white-space: unset; padding: 3px 0;">
                            {{ $t('Hereby, the department confirms, in agreement with the legal representative, the correctness and release of this data in connection with the sponsorship.') }}
                        </el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top:15px;">
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('formData')">{{ (formData.edit? $t('Update'):$t('Save')) }}</el-button>
                        <el-button type="cancel" @click="$emit('popup',false)">{{ $t('Cancel') }}</el-button>
                    </el-form-item>
                </el-col>
            <!-- </el-row> -->
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        components: {
            VueGoogleAutocomplete
        },
        props: {
            dialogFormVisible: Boolean,
            rowData: Object,
            fachstellenType: Object,
            organization_slug: String,
            fachstellen_slug: String
        },
        created() {
            this.filteredCountry = this.countryList;
        },
        data() {
            return {
                formData: {
                    publication_type: 'no',
                    q_ans_5: 'no',
                    zipcode: null
                },
                countryList: process.env.KIPAKI_country_list,
                filteredCountry: [],
                fachstellenName: {},
                formLabelWidth: '120px',
                rules: {
                    first_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    last_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    nick_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    gender: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    place: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: ['blur', 'change']
                    }],
                    fachstellen_type: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    fachstellen_slug: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    life_situation: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    legal_parent_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    legal_parent_type: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    dob: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    admission: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    origin_country: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    description: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    confirmation: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    publication_type: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                }
            };
        },
        methods: {
            getFetchStellen() {
                request({
                        url: "get-all-fachstellen",
                        method: "get",
                        params: {
                            fachstellen_type: this.formData.fachstellen_type,
                            organization_slug: this.organization_slug
                        }
                    })
                    .then(response => {
                        this.fachstellenName = response.data
                    })
                    .catch(error => {});
            },
            fachstellenTypeChange(val) {
                this.formData.fachstellen_slug = null;
                this.getFetchStellen();
            },
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                    this.$refs.address.update(this.formData.address);
                });
                if (this.formData.fachstellen_type) {
                    this.getFetchStellen();
                }
            },
            handleClose() {
                this.$emit('popup', false)
            },
            handleAddressChange(address) {
                this.formData.address = address;
                this.$refs['formData'].validateField('address');
            },
            getAddressData: function (addressData, placeResultData, id) {
                this.formData.address = placeResultData.formatted_address;
                this.formData.place = placeResultData.vicinity;
                this.formData.zipcode = addressData.postal_code
            },
            updateData(row) {
                return request({
                        url: "patenkinders/" + row.patenkinder_slug,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit)
                            return this.updateData(this.formData);
                        request({
                                url: "patenkinders",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit('popup', false);
                                this.$emit('popupsave', false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            },
            filterCountry(filterValue) {
                let countryListArray = Object.values( this.countryList );
                this.filteredCountry = countryListArray.filter(country => {
                    return country.toLowerCase().indexOf(filterValue.toLowerCase()) == 0;
                });
            }
        }
    } 

</script>
<style lang="scss" scoped>
    .publication_type label {
        width: 100%;
        margin-left: 0 !important;
        white-space: normal;
    }
    .terms span.el-checkbox__label{
        width: 90%;vertical-align: top;
    }
    .el-form-item__label {
        text-transform :none !important;
    }
    .admision-label {
        word-break: break-word !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Layout/Patenkinder/Form.vue